import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '..';

type TokenRes = {
  powerbi_token: string;
};

export const PowerBiApi = createApi({
  reducerPath: 'powerbi-token',
  tagTypes: ['powerbi-token'],
  baseQuery,
  endpoints: (builder) => ({
    getPowerBiToken: builder.query<TokenRes, string>({
      query: (url) => ({
        url,
        method: 'POST',
      }),
      extraOptions: {
        pollingInterval: 2 * 60 * 60 * 1000, // 2 hours
      },
      providesTags: ['powerbi-token'],
    }),
  }),
});

export const { useGetPowerBiTokenQuery } = PowerBiApi;
